import { DndContext } from "@dnd-kit/core";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import store from "../../../../_services/store";
import { Image } from "../../../_ui";
import quizztext from '../../../../_translations/quizz.json';
import Draggable from "../draggable";
import Droppable from "../droppable";
import ImageAnswer from "./image-answer";
import { DragContainer, DropContainer, DroppableContainer, Label, ValidateButton } from "../components";
import { ReactComponent as BackButtonArrow } from '../../../../assets/svg/left-arrow.svg';
import { shuffleArray } from "../../../../_services/utils/utils";
import Modal from "../modal";

const modalDefaultProps = {
  isOpen: false,
  title: "",
  content: "",
  btn1: {
    label: "",
    func: () => { }
  }
}

const QuizzImage = observer(() => {
  const navigate = useNavigate();
  const [userAnswers, setUserAnswers] = useState<(TResponse | null)[]>([null, null, null, null]);
  const [subQuestionId, setSubQuestionId] = useState<number>(0);
  const [modal, setModal] = useState<TQuizzModalProps>(modalDefaultProps);

  const goNext = () => {
    const nextIndex = subQuestionId + 1;
    console.log("gotoNext question", store.questionIndex, currentQuestion.question_response.response?.[nextIndex.toString()]);

    //if there is a next another question
    if (currentQuestion.question_response.response?.[nextIndex.toString()]) {
      setSubQuestionId(nextIndex);
    } else {
      console.log(" -- gotoNext question index: no more question", store.questionIndex);
    }
  };

  const goBack = () => {
    const nextIndex = subQuestionId - 1;
    if (currentQuestion.question_response.response?.[nextIndex.toString()]) {
      setSubQuestionId(nextIndex);
    } else {
      console.log(" -- gotoBack question index: no more question", store.questionIndex);
    }
  }

  if (store.quizzes === null || store.currentQuestion === null) {
    return <p>No Quizzes or no questions, should not happen</p>;
  }

  const currentQuestion = store.currentQuestion.data;
  if (!currentQuestion) return <></>;

  const PossibleAnswersCount = currentQuestion.question_response.response.length;

  useEffect(()=>{
    setDefaultAnswers(PossibleAnswersCount);
  }, [])

  function validateAnswer(response: TResponse): 1 | 0 {
    return response.content === currentQuestion.question_response.response[subQuestionId].content ? 1 : 0;
  }

  function handleDragEnd(event) {
    if (event.over && event.over.id === 'droppable') {
      const { question_id } = currentQuestion.question_response;
      const currentResponse = currentQuestion.question_response.response.find(e => e.id === event.active.id);

      if (!currentResponse || !currentQuestion) return;
      currentResponse.is_the_answer = validateAnswer(currentResponse);

      store.setQuizzResp({
        id: store.quizzId,
        val: {
          [question_id]: {
            val: event.active.id,
            validated: validateAnswer(currentResponse),
          },
        },
      });

      const dropped = [...userAnswers]
      dropped[subQuestionId] = currentResponse
      setUserAnswers(dropped);
    }
  }

  function modifyAnswer() {
    const answers = [...userAnswers]
    answers[subQuestionId] = null;
    setUserAnswers(answers);
  }

  function submitAnswers() {
    const resultIsGood: boolean = userAnswers
      .map(e => e?.is_the_answer)
      .reduce<number>((acc, val) => acc + (val || 0), 0) === 4;

    if (resultIsGood) {
      setModal({
        isOpen: true,
        title: "Bravo",
        content: "Vous n’avez fait aucune faute",
        btn1: {
          label: "Passer au suivant",
          func: () => { save() }
        }
      });
    }
    else {
      setModal({
        isOpen: true,
        title: "Deuxième chance",
        content: "Vous avez fait des erreurs, souhaitez-vous valider ou réessayer ?",
        btn1: {
          label: "Valider",
          func: () => { save() }
        },
        btn2: {
          label: "Réessayer",
          func: () => { retry() }
        }
      });
    }
  }

  function save() {
    store.sendQuizzResults();
    setModal({ ...modal, ...{ isOpen: false } });
    navigate(-1);
  }
  function retry() {
    setModal({ ...modal, ...{ isOpen: false } });
    setDefaultAnswers(PossibleAnswersCount);
    setSubQuestionId(0);
  }

  function setDefaultAnswers(length: number){
    const newAnswers: null[] = [];
    for (let index = 0; index < length; index++) {
      newAnswers.push(null);
      setUserAnswers(newAnswers);
    }
  }

  const PossibleAnswersElements = currentQuestion.question_response.response.map((answer, i) => {
    if (!userAnswers.includes(answer)) {
      return <Draggable key={answer.content} style={{ padding: 0 }} answer={answer}>
        <ImageAnswer answer={answer} />
      </Draggable>
    }
    else {
      return <Image src="" style={{ borderRadius: 10, opacity: 0.25 }} width={128} height={128} />
    }
  });

  const answersCount = userAnswers.filter(e => e).length;

  return (
    <div className="fadeIn">
      <DndContext onDragEnd={handleDragEnd}>

        <DropContainer>
          <Label style={{fontSize: 14}}>{currentQuestion.question_response.response[subQuestionId].content}</Label>
          <DroppableContainer>
            <BackButtonArrow style={{marginRight: 15, padding: 10}} onClick={goBack} />
            <Droppable>
              {!userAnswers[subQuestionId] && null}
              {userAnswers[subQuestionId] !== null && <Image src={userAnswers[subQuestionId]?.img} style={{ borderRadius: 10 }} width={128} height={128} />}
            </Droppable>
            <BackButtonArrow style={{marginLeft: 15, padding: 10}} className="rotate" onClick={goNext} />
          </DroppableContainer>
          <ValidateButton disabled={!!!userAnswers[subQuestionId]} onClick={modifyAnswer}>Modifier</ValidateButton>
        </DropContainer>

        <DragContainer>
          {PossibleAnswersElements}
        </DragContainer>

      </DndContext>

      {answersCount === PossibleAnswersCount && <ValidateButton onClick={submitAnswers}>Valider vos choix</ValidateButton>}

      <Modal
        isOpen={modal.isOpen}
        title={modal.title}
        content={modal.content}
        btn1={modal.btn1}
        btn2={modal.btn2}
      />
    </div>
  )
})

export default QuizzImage;